<template>
  <div class="contactWay">
    <div class="contact" :class="{ 'contact-top': !flag, contactTop: isCourse }">
      <ul>
        <!-- @click="ImBoxShow = true" -->
        <!-- <li>
          <div class="img">
            <a
              href="http://p.qiao.baidu.com/cps/chat?siteId=14771035&userId=28298753&siteToken=da458e98f4fe10cf02abab29b4bc0804"
              target="_blank"
            >
              <img src="../assets/img/service.png" alt="客服" />
              <p class="label">客服</p>
            </a>
          </div>
        </li> -->
        <li>
          <div class="img">
            <Poptip trigger="hover" width="250" placement="left">
              <img src="../assets/img/QQ.png" alt="QQ" />
              <p class="label">QQ</p>
              <div slot="content">
                <div class="qqList">
                  <div class="qqItem">
                    <a
                      class="display-flex align-items-center display-flex align-items-center"
                      href="tencent://message/?uin=2905563601"
                    >
                      <div class="qqleft display-flex align-items-center">
                        <img src="../assets/img/QQX.png" alt />
                        <span>QQ1</span>
                      </div>
                      <div class="qqright flex-1">2905563601</div>
                    </a>
                  </div>
                  <!-- <div
                    class="qqItem"
                  >
                   <a
                      class="display-flex align-items-center display-flex align-items-center"
                      href="tencent://message/?uin=1985486806"
                    >
                    <div class="qqleft display-flex align-items-center">
                      <img src="../assets/img/QQX.png" alt />
                      <span>QQ2</span>
                    </div>
                    <div class="qqright flex-1">1985486806</div>
                   </a>
                  </div> -->
                  <!-- <div
                    class="qqItem"
                  >
                   <a
                      class="display-flex align-items-center display-flex align-items-center"
                      href="tencent://message/?uin=290478357"
                    >
                    <div class="qqleft display-flex align-items-center">
                      <img src="../assets/img/QQX.png" alt />
                      <span>QQ3</span>
                    </div>
                    <div class="qqright flex-1">290478357</div>
                   </a>
                  </div> -->
                </div>
              </div>
            </Poptip>
          </div>
        </li>
        <li>
          <div class="img">
             <Poptip trigger="hover" width="250" placement="left">
            <img src="../assets/img/weixin_on.png" alt="微信" />
            <p class="label">微信</p>
            
              <div slot="content">
                  <img style="width:180px" src="../assets/img/jxjykf.png" alt="微信二维码" />
              <p>微信扫一扫</p>
              </div>
            </Poptip>
          </div>
        </li>
        <li>
          <div class="img contact-img">
            <img src="../assets/img/code2.png" alt="公众号" />
            <p class="label">公众号</p>
            <img class="contact-img-son" src="../assets/img/code.png" />
          </div>
        </li>
        <li>
          <div class="img">
			  <Poptip trigger="hover" width="250" placement="left">
				<img src="../assets/img/code1.png" alt="APP下载" />
				<p class="label">APP下载</p>
			  
			    <div slot="content">
			        <img style="width:180px" src="../assets/img/android.png" alt="微信二维码" />
					<p>android下载</p>
					<img style="width:180px" src="../assets/img/ios.png" alt="微信二维码" />
					<p>ios下载</p>
			    </div>
			  </Poptip>
          </div>
        </li>
      </ul>
    </div>
    <ImBox v-if="ImBoxShow" @close="ImBoxShow = false" />
  </div>
</template>

<script>
import ImBox from "./ImBox.vue";

export default {
  name: "contactWay",
  components: { ImBox },
  data() {
    return {
      ImBoxShow: false
    };
  },
  created() {},
  mounted() {},
  computed: {
    flag() {
      return this.$store.state.isHome;
    },
    isCourse() {
      return this.$store.state.isCourse;
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.contact.contactTop {
  top: 240px !important;
}
.contact {
  padding-top: 5px;
  background: #fff;
  position: fixed;
  right: calc(50% - 600px - 20px - 65px);
  // right: 50%;
  top: 280px;
  .qqList {
    font-size: 14px;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
    line-height: 50px;
    .qqItem {
      cursor: pointer;
      border-bottom: 1px solid #ddd;
      span {
        color: #e06640;
        margin-left: 5px;
      }
    .qqright{
      color: #333;
    }
    }
    .qqItem:last-child {
      border: none;
    }
  }
  &-top {
    top: 135px;
  }
  img {
    // border: 1px dashed #aaa;
  }
  &-img {
    position: relative;
    &-son {
      position: absolute;
      right: 68px;
      top: 0;
      display: none;
    }
  }
  &-img:hover {
    .contact-img-son {
      display: block;
    }
  }
  ul {
    text-align: center;
    width: 65px;
    li {
      padding: 0 5px;
      .img {
        border-bottom: 1px solid #ddd;
        margin-bottom: 5px;
      }
    }
    li:last-child {
      .img {
        border: none;
      }
    }
    .label {
      font-size: 14px;
      font-weight: 400;
      color: rgba(34, 34, 34, 1);
      margin-top: -8px;
      margin-bottom: 10px;
    }
  }
}
</style>
